import { Space, Typography } from 'antd'

/** A human name with its technical code in grey beside it; the code alone when there is no name. */
export function NamedCode({ name, code }: { name: string | null; code: string }) {
  if (name === null) return <Typography.Text code>{code}</Typography.Text>
  return (
    <Space size={6} wrap>
      <Typography.Text>{name}</Typography.Text>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {code}
      </Typography.Text>
    </Space>
  )
}
